import { createAction } from '@src/redux/helpers/createAction';
import { VALIDATE_TERMS, UPDATE_TERMS } from './constants';
import { updateTermsOfUse, validateTermsOfUse } from './requests';

export const updateTerms = (query, onSuccess, onError) => {
  return createAction({
    type: UPDATE_TERMS,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: updateTermsOfUse,
    },
  });
};

export const validateTerms = (query, onSuccess, onError) => {
  return createAction({
    type: VALIDATE_TERMS,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: validateTermsOfUse,
    },
  });
};
